import { memo } from 'react';
import { Typography } from '../../../../../components/typography/typography';

export const ProductItemOwner = memo(
  ({ equipmentOwner }: { equipmentOwner?: string }) => {
    if (!equipmentOwner) return null;
    return (
      <Typography type="text-xs" weight="regular" className="m-[2px] text-quipli-grey-400" dataCy="equipment-owner">
        Equipment Owner: {equipmentOwner}
      </Typography>
    );
  },
  (prevProps, nextProps) => {
    return prevProps.equipmentOwner === nextProps.equipmentOwner;
  },
);
